export default "__VITE_ASSET__1fedcb7a__"